export default __webpack_public_path__ + "static/media/078.544954c1.jpeg";